import { render, staticRenderFns } from "./preview-component.vue?vue&type=template&id=4d33df0e&scoped=true&"
import script from "./preview-component.vue?vue&type=script&lang=js&"
export * from "./preview-component.vue?vue&type=script&lang=js&"
import style0 from "./preview-component.vue?vue&type=style&index=0&id=4d33df0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d33df0e",
  null
  
)

component.options.__file = "preview-component.vue"
export default component.exports